"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrashIcon = exports.StyledContainerSpinner = exports.StyledImage = exports.StyledContainerImage = exports.StyledCheckMark = exports.StyledDeleteButton = exports.StyledContainerImageUpload = exports.StyledFileSeletor = exports.StyledFileContainer = exports.StyledContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRainbowComponents = require("react-rainbow-components");

var _icons = require("@rainbow-modules/icons");

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__StyledContainer",
  componentId: "sc-13nwbiq-0"
})(["display:flex;flex-wrap:wrap;padding:10px 20px;"]);

exports.StyledContainer = StyledContainer;

var StyledFileContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__StyledFileContainer",
  componentId: "sc-13nwbiq-1"
})(["height:190px;width:200px;margin-right:10px;margin-bottom:10px;overflow:hidden;"]);

exports.StyledFileContainer = StyledFileContainer;
var StyledFileSeletor = (0, _styledComponents["default"])(_reactRainbowComponents.FileSelector).withConfig({
  displayName: "styled__StyledFileSeletor",
  componentId: "sc-13nwbiq-2"
})(["display:block;width:200px;height:160px;margin-right:10px;margin-bottom:10px;> div{border-radius:6px;min-height:auto;}"]);
exports.StyledFileSeletor = StyledFileSeletor;

var StyledContainerImageUpload = _styledComponents["default"].div.withConfig({
  displayName: "styled__StyledContainerImageUpload",
  componentId: "sc-13nwbiq-3"
})(["display:flex;align-items:center;justify-content:center;width:100%;height:160px;> div{width:70px;height:70px;}h1{display:none;}"]);

exports.StyledContainerImageUpload = StyledContainerImageUpload;
var StyledDeleteButton = (0, _styledComponents["default"])(_reactRainbowComponents.ButtonIcon).withConfig({
  displayName: "styled__StyledDeleteButton",
  componentId: "sc-13nwbiq-4"
})(["position:absolute;top:8px;right:2px;display:none;"]);
exports.StyledDeleteButton = StyledDeleteButton;
var StyledCheckMark = (0, _styledComponents["default"])(_icons.Check).withConfig({
  displayName: "styled__StyledCheckMark",
  componentId: "sc-13nwbiq-5"
})(["color:#fff;position:absolute;top:18px;left:16px;display:none;"]);
exports.StyledCheckMark = StyledCheckMark;

var StyledContainerImage = _styledComponents["default"].button.withConfig({
  displayName: "styled__StyledContainerImage",
  componentId: "sc-13nwbiq-6"
})(["position:relative;width:100%;height:160px;overflow:hidden;border-radius:6px;margin-bottom:0.5rem;border:0;padding:0;background-clip:padding-box;box-shadow:rgb(215,217,226) 0 1px 2px 0;&:hover ", "{display:block;}&:hover ", "{display:block;}&:hover,&:focus{border:0;padding:0;&::before{content:'';overflow:hidden;position:absolute;top:0;right:0;bottom:0;left:0;background-image:linear-gradient( to bottom,rgba(0,0,0,0.29),rgba(0,0,0,0.05) 81% );}}&:focus{outline:0;box-shadow:", ";}"], StyledDeleteButton, StyledCheckMark, function (props) {
  return props.theme.rainbow.shadows.brand;
});

exports.StyledContainerImage = StyledContainerImage;

var StyledImage = _styledComponents["default"].img.withConfig({
  displayName: "styled__StyledImage",
  componentId: "sc-13nwbiq-7"
})(["display:", ";"], function (props) {
  return props.$loading ? 'none' : 'block';
});

exports.StyledImage = StyledImage;

var StyledContainerSpinner = _styledComponents["default"].div.withConfig({
  displayName: "styled__StyledContainerSpinner",
  componentId: "sc-13nwbiq-8"
})(["display:flex;width:100%;height:100%;justify-content:center;"]);

exports.StyledContainerSpinner = StyledContainerSpinner;
var TrashIcon = (0, _styledComponents["default"])(_icons.Trash).withConfig({
  displayName: "styled__TrashIcon",
  componentId: "sc-13nwbiq-9"
})(["width:60px;height:60px;margin:12px 12px 20px 0;color:", ";"], function (props) {
  return props.theme.rainbow.palette.error.main;
});
exports.TrashIcon = TrashIcon;